package blazern.lexisoup.feature.settings.ui

import org.koin.core.annotation.KoinExperimentalAPI
import org.koin.viewmodel.scope.ScopeViewModel

@OptIn(KoinExperimentalAPI::class)
class SettingsViewModel : ScopeViewModel()
